export default {"src":"/_next/static/media/icon_stakes_selected_checkmark.b78c0d6b.svg","height":9,"width":10,"blurWidth":0,"blurHeight":0};